import CalendarCancelSVG from "@design-system/ui-icons/vanilla/CalendarCancel"
import { createIcon } from "../createIcon"

export const CalendarCancelIcon = createIcon(CalendarCancelSVG)
